import {Theme} from "@mui/material";

const styles = (_theme: Theme) => ({
    root: {
    },
});

export default styles;
